<div [hidden]="hidden">
    <mat-form-field [ngClass]="{'full-width': fullWidth}">
        <mat-select #select [(value)]="value" [class]="selectClass" [id]="name" ngDefaultControl
            (openedChange)="openedChange($event)" [multiple]="multiple" [disabled]="disabled" [placeholder]="required ? label + ' *' : label "
            [panelClass]="['iv-select', name, search ? 'with-search': '']" (selectionChange)="change($event)"
            [formControl]="formControl ? formControl : null">
            <span [ngStyle]="{'max-width': width || '100%' }">
                <mat-form-field class="full-width select-search" *ngIf="search" [appearance]="mode">
                    <input #searchInput="matInput" matInput [(ngModel)]="query" (input)="filter();" name="select-search"
                        *ngIf="search" autocomplete="off">
                    <i class="material-icons" matSuffix>search</i>
                </mat-form-field>

                <ng-container *ngIf="groups">
                    <mat-optgroup *ngFor="let group of options" [label]="group.label">
                        <mat-option *ngFor="let item of group.items" [value]="item.value" matTooltip="{{item.label}}">
                            {{item.label}}
                        </mat-option>
                    </mat-optgroup>
                </ng-container>
                <ng-container *ngIf="!groups && options.length">
                    <mat-option (onSelectionChange)="onOptionSelected($event)" (onSelectionChange)="onOptionSelected($event)" #opt
                        *ngFor="let option of options; let i = index; let $last = last" [hidden]="option.hidden"
                        [value]="option.value" [attr.data-index]="i" [attr.data-level]="option.level"
                        [attr.data-parent]="option.parent"
                        [ngClass]="{'parent-option': option.isParent, 'child-option': option.parent }"
                        [matTooltip]="openPanel ? (showtooltip(opt) ? option.label : '') : ''">
                        <ng-container *ngIf="option.level">
                            <span class="span" [ngStyle]="{'width': option.widthDistance }" *ngIf="option.level > 1"></span>
                            <mat-icon class="material-icons">subdirectory_arrow_right</mat-icon>
                        </ng-container>
                        <span>{{option.label}}</span>
                    </mat-option>

                </ng-container>
            </span>
        </mat-select>
        <mat-error *ngIf="getErrorMessage()?.length">
            {{getErrorMessage()[0]}}
        </mat-error>
    </mat-form-field>
    <button *ngIf="name === 'prefixes'" mat-icon-button (click)="onIconClick($event)">
        <mat-icon>add_ic_call</mat-icon>
    </button>
</div>
